export enum AuctionStatusEnum {
    Active= 'Active',
    Finished = 'Finished',
}
